import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import DropDown from '../DropDown';
import FormElement from '../FormElement';
import MenuItem from '@mui/material/MenuItem';
import isStringSet from '../../utilities/is/isStringSet';
import styles from './styles';

/**
 * A component to enable the selection of an video input source
 */
class VideoInputDeviceList extends React.Component {

    state = {
        availableDevices: []
    };

    async componentDidMount() {
        const devices = await this.props.codeReader.getVideoInputDevices();

        let selectedDeviceId = this.props.deviceId;

        if (!isStringSet(selectedDeviceId)) {
            selectedDeviceId = devices.length > 0 ? devices[0].deviceId : '';
        } else {
            let isValidDevice = devices.filter(d => d.deviceId === selectedDeviceId).length > 0;
            if (!isValidDevice) {
                selectedDeviceId = devices.length > 0 ? devices[0].deviceId : '';
            }
        }

        this.setState({ availableDevices: devices });

        if (this.props.onDeviceListLoaded) {
            this.props.onDeviceListLoaded(devices);
        }

        setTimeout(() => {
            // trigger the device changed handler to start using the first device that was found
            this.props.onDeviceChanged(selectedDeviceId);
        }, 400);
    }

    handleDeviceChange = (evt) => {
        const deviceId = evt.target.value;

        // trigger the device changed handler to start using the first device that was found
        this.props.onDeviceChanged(deviceId);
    };

    render() {
        const { availableDevices } = this.state;
        const { classes, deviceId } = this.props;

        return (
            <FormElement className={classes.formControl} fullWidth>
                <DropDown
                    value={deviceId || ''}
                    onChange={this.handleDeviceChange}
                    inputProps={{
                        id: 'device-selector',
                        name: 'device-selector'
                    }}>
                    {availableDevices.map(device =>
                        <MenuItem key={device.deviceId} value={device.deviceId}>{device.label}</MenuItem>
                    )}
                </DropDown>
            </FormElement>
        );
    }
}

VideoInputDeviceList.propTypes = {
    deviceId: PropTypes.string,
    onDeviceChanged: PropTypes.func.isRequired,
    onDeviceListLoaded: PropTypes.func.isRequired
};

const styledVideoInputDeviceList = withStyles(VideoInputDeviceList, styles);

export default styledVideoInputDeviceList;